import { render } from "./IStoreSidebarNav.vue?vue&type=template&id=bed16a7e"
import script from "./IStoreSidebarNav.vue?vue&type=script&lang=js"
export * from "./IStoreSidebarNav.vue?vue&type=script&lang=js"

import "./IStoreSidebarNav.vue?vue&type=style&index=0&id=bed16a7e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__